// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3MGu4","info":"PatientInfo_info__2elih"};